module.exports = __webpack_public_path__ + "img/logo-um-ft.2608c3d7.png";